export default {
  text: '#868786',
  primary: '#c3922b',
  secondary: '#083e2a',
  background: '#fdfdfd',
  backgroundSecondary: '#f0f0e6',
  light: '#fdfdfd',
  dark: '#484848'
}
